import { useTranslation } from "react-i18next"
import { Box, Stack, Typography } from "@mui/material"
import CheckRoundedIcon from "@mui/icons-material/CheckRounded"

import { SectionCard } from "widgets/styled/containers"
import AlertsOverviewLink from "./AlertsOverviewLink"
import LastUpdated from "./LastUpdated"

interface NoOpenAlertsCardProps {
  lastUpdatedAt?: number
}

const NoOpenAlertsCard = ({ lastUpdatedAt }: NoOpenAlertsCardProps) => {
  const { t } = useTranslation()

  return (
    <SectionCard
      data-testid="no-open-alerts-card"
      sx={{
        my: 0,
        p: { xs: 2, md: 2.5 },
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        columnGap: 2,
        rowGap: 1,
      }}
    >
      <Box>
        <Stack direction="row" alignItems="center" gap={1}>
          <CheckRoundedIcon color="secondary" fontSize="small" />
          <Typography variant="h4" component="p">
            {t("alerts.NO_OPEN_ALERTS")}
          </Typography>
        </Stack>
        <LastUpdated at={lastUpdatedAt} />
      </Box>
      <AlertsOverviewLink />
    </SectionCard>
  )
}

export default NoOpenAlertsCard
